export class LanguageDefinition{

	countryCode : string;
	countryNameNative : string;
	countryName : string;
	languageNameNative : string;
	languageName : string;
	locale: string;
	languageFile : string;
	infoTextFile : string;
	getCountryCode(){
		return this.countryCode;
	}
	
	getCountryNameNative(){
		return this.countryNameNative;
	}
	
	getCountryName(){
		return this.countryName;
	}
	
	getLanguageNameNative(){
		return this.languageNameNative;
	}
	
	getLanguageName(){
		return this.languageName;
	}

	getLocale(){
		return this.locale;
	}
	
	getLanguageFile(){
		return this.languageFile;
	}

	getInfoTextFile(){
		return this.infoTextFile;
	}
	constructor(data:any){
		
		if(data['countryCode']){
			this.countryCode = data['countryCode'];
		}
		if(data['countryNameNative']){
			this.countryNameNative = data['countryNameNative'];
		}
		if(data['countryName']){
			this.countryName = data['countryName'];
		}
		
		if(data['languageName']){
			this.languageName = data['languageName'];
		}
		
		if(data['languageNameNative']){
			this.languageNameNative = data['languageNameNative'];
		}
		
		if(data['locale']){
			this.locale = data['locale'];
		}
		if(data['languageFile']){
			this.languageFile=data['languageFile'];
		}
		if(data['infoTextFile']){
			this.infoTextFile = data['infoTextFile'];
		}
	}

}